import KunLoading53 from './src/index'

KunLoading53.install = function (Vue) {
	Vue.component(KunLoading53.name, KunLoading53);
}

export default KunLoading53;
